import { Facebook, Instagram, Linkedin, Mic2 } from "lucide-react";
import { Link } from "react-router-dom";
import GlobalFooter from "./GlobalFooter";
import { performances, categories } from "@/data/performances";

export const Footer = () => {
  const getCategoryPerformances = (categorySlug: string) =>
    performances.filter((p) => p.category === categorySlug);

  return (
    <footer className="bg-[hsl(240,10%,3%)] border-t border-border py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 text-center md:text-left">
          <div>
            <div className="flex items-center gap-2 justify-center md:justify-start mb-4">
              <Mic2 className="w-6 h-6 text-primary" />
              <h3 className="font-space-grotesk font-bold text-xl text-foreground">Wystep.pl</h3>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Profesjonalne występy artystyczne dla firm,<br />
              które uświetniają każde wydarzenie.
            </p>
          </div>
          <div>
            <h4 className="font-space-grotesk font-bold text-foreground mb-4">Kontakt</h4>
            <p className="text-muted-foreground text-sm">
              Email: <a href="mailto:kontakt@wystep.pl" className="hover:text-primary transition-colors">kontakt@wystep.pl</a>
            </p>
            <p className="text-muted-foreground text-sm">Tel: +48 533 333 993</p>
          </div>
          <div>
            <h4 className="font-space-grotesk font-bold text-foreground mb-4">Social Media</h4>
            <div className="flex gap-3 justify-center md:justify-start">
              {[Facebook, Instagram, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-xl glass flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/30 transition-all">
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* SEO Footer Links - Kategorie atrakcji */}
        <div className="mt-12 pt-8 border-t border-border/30">
          <h4 className="font-space-grotesk font-bold text-foreground text-center mb-8">Nasze atrakcje</h4>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
            {categories.map((cat) => (
              <div key={cat.slug}>
                <h5 className="font-space-grotesk font-semibold text-foreground/80 text-xs uppercase tracking-wider mb-3">
                  {cat.name}
                </h5>
                <ul className="space-y-1.5">
                  {getCategoryPerformances(cat.slug).map((perf) => (
                    <li key={perf.slug}>
                      <Link
                        to={`/atrakcje/${perf.slug}`}
                        className="text-muted-foreground/70 text-xs hover:text-primary transition-colors leading-tight block"
                      >
                        {perf.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mt-8 text-xs text-muted-foreground">
          <Link to="/rodo" className="hover:text-primary transition-colors">Obowiązek informacyjny RODO</Link>
          <span className="text-border">|</span>
          <Link to="/polityka-prywatnosci" className="hover:text-primary transition-colors">Polityka prywatności</Link>
          <span className="text-border">|</span>
          <Link to="/regulamin" className="hover:text-primary transition-colors">Regulamin serwisu</Link>
        </div>
        <GlobalFooter />
      </div>
    </footer>
  );
};
